export function composeInitialsName(name: string) {
  const isSplited = name?.split(' ').length > 1

  if (!isSplited) {
    return name?.charAt(0)
  }

  const letters = name?.split(' ').map((name) => name.charAt(0))
  return `${letters[0]}${letters.pop()}`
}
